module.exports = __webpack_public_path__ + "static/media/1.cda7c98f.jpg";